
import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext"

import Header from "../components/header"
import Footer from "../components/footer"
import Body from "../components/body"

import CompanyInfo from "../components/companyInfo";
import UsersCount from "../components/usersCount";
import MachinesList2 from "../components/machineList2";
import ProdList1 from "../components/prodlist";
import ShiftList1 from "../components/shiftList";
import ActTypeList1 from "../components/activityTypeList";
import ActivityList1 from "../components/activityList1";
import OperatorList1 from "../components/operatorList1";


const OperatorL1 = () => {

  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));


  return (
    <>
      <div className="body">
        <Header />
        <h2>{t('operator3')}</h2>

        <div>
          <OperatorList1 id_c={company.id_c} />

        </div>
      </div>
    </>
  )
}

export default OperatorL1;